import React from "react";

const Scholarships = () => {
  const scholarshipData = [
    {
      srNo: 1,
      course: "B.Sc. Nautical Science",
      scholarship: "30000/-",
    },
    {
      srNo: 2,
      course: "B.Tech Marine Engineering",
      scholarship: "50000/-",
    },
    {
      srNo: 3,
      course: "B.Tech Marine Engineering (Lateral Entry)",
      scholarship: "30000/-",
    },
    {
      srNo: 4,
      course:
        "B.Tech Marine Engineering (Lateral Entry) Meritorious students from low-income background - Income less than 8 lakh (only 5 students)",
      scholarship: "75000/-",
    },
  ];

  return (
    <div>
      <h1 className="title">Scholarship Details</h1>
      <hr />
      <table className="page-content-table">
        <thead>
          <tr>
            <th>Sr.No.</th>
            <th>Courses</th>
            <th>Scholarship</th>
          </tr>
        </thead>
        <tbody>
          {scholarshipData.map((item) => (
            <tr key={item.srNo}>
              <td>{item.srNo}</td>
              <td>{item.course}</td>
              <td>{item.scholarship}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/*  Note Section */}
      <div>
        <h4 className="innerpage-subheading">Note:</h4>
        <ul className="page-content-lists ">
          <li>
            Entry-level scholarship amount will be deducted from the first-year
            fees at the time of admission.
          </li>
          <li>
            Scholarship will be awarded to only the Top 10 students from each
            course based on PCM % or diploma final year percentage.
          </li>
          <li>Continuation of scholarship is based on academic performance.</li>
          <li>
            Eligible students will get the benefit of any one scholarship from
            above.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Scholarships;
